import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import { ReactComponent as PracticeTabIcon } from "../../../Assets/Images/PracticeTab.svg";

interface PracticeTabProps {
  name: string; // <-- add the prop type here
}

// --- ICONS (Placeholders) ---
const IconPlay = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="5 3 19 12 5 21 5 3"></polygon>
  </svg>
);

export const PracticeTab: FunctionComponent<PracticeTabProps> = ({ name }) => {
  const navigate = useNavigate();
  return (
    <div className="tab-content-container">
      <div className="practice-container">
        <h4 className="practice-header">
          <PracticeTabIcon /> Practice What You've Learned
        </h4>
        <p className="practice-description">
          Ready to test your {name} skills? Take the practice
          test to apply what you've learned.
        </p>
        <div className="practice-buttons">
          <button
            className="start-test-button"
            onClick={() => {
              navigate("/practicetest");
            }}
          >
            <PlayArrowOutlinedIcon sx={{ fontSize: "20px" }} /> Start {name} Test
          </button>
          <button
            className="view-all-tests-button"
            onClick={() => {
              navigate("/practicetest");
            }}
          >
            <ArrowForwardOutlinedIcon />
            View All Tests
          </button>
        </div>
        <div className="whats-next-section">
          <h5 className="whats-next-header">What's Next?</h5>
          <ul className="whats-next-list">
            <li>Apply {name} strategies you've learned</li>
            <li>Practice with various text types and questions</li>
            <li>Improve your {name} speed and accuracy</li>
            <li>Build confidence for the actual exam</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
